import { render, staticRenderFns } from "./HmsSettings.vue?vue&type=template&id=c4e15332&"
import script from "./HmsSettings.vue?vue&type=script&lang=ts&"
export * from "./HmsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports